import { RowDataKPIObjective } from "../../components/KpiPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the KPIObjectiveTable factory
 */
class KPIObjectiveRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/kpi/objective/read-range"
        this.accessData = "kpiObjectives"
    }

    create(kpiObjective: any): RowDataKPIObjective {
        const rowDataKpiObjective: RowDataKPIObjective = {
            objectiveId: kpiObjective.kpi_objective_id,
            title: kpiObjective.title,
            description: kpiObjective.description,
            action: "",
        };
        return rowDataKpiObjective;
    }
}

let kpiObjectiveRow: KPIObjectiveRow | null = null;

export default function getKPIObjectiveRow(): KPIObjectiveRow {
    if (kpiObjectiveRow === null)
        kpiObjectiveRow = new KPIObjectiveRow()
    return kpiObjectiveRow
}